/**
 * Observer class
 */
class KinesisService {

  constructor() {
    // Initialize the Amazon Cognito credentials provider
    AWS.config.region = BACKEND_REGION_NAME; // Region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: BACKEND_COGNITO_POOL_ID,
    });
    this.firehose = new AWS.Firehose();
  }

  sendEvent(logData) {
    this.firehose.putRecord({
      DeliveryStreamName: BACKEND_STREAM_NAME,
      Record: {
        Data: JSON.stringify(logData) + '\n'
      }
    }, (err, data) => {
      if (err) console.log(err, err.stack); // an error occurred
    })
  }
}

export default KinesisService;



// WEBPACK FOOTER //
// ./src/modules/analyticsLibrary/KinesisService.js